/**
 * useAnalytics Hook
 *
 * Product analytics are NOT recorded: POST /analytics/events answers 501
 * NOT_AVAILABLE (the server stores no events). The tracker is therefore a
 * no-op that sends nothing — no request that is known to fail, and nothing
 * that pretends an event was recorded. Call sites keep their `track(...)`
 * calls so a real analytics sink can be wired here later in one place.
 */

import { useCallback } from 'react';
import type { AnalyticsEventType, AnalyticsEventPayload } from '../store/api/analyticsApi';

export function useAnalytics() {
  /** Records nothing (no analytics backend); never throws. */
  const track = useCallback((_type: AnalyticsEventType, _payload?: AnalyticsEventPayload) => {
    // Intentionally empty: see the module comment.
  }, []);

  return { track };
}

export type { AnalyticsEventType, AnalyticsEventPayload };
